import { MapCultureTo } from "../../base-types";
import { IHierarchicalOptionListValue } from "../../contracts/base/option-lists/option-list-value";
import OptionListValueBase from "../../contracts/base/option-lists/option-list-value-base";

export default class HierarchicalOptionListValue extends OptionListValueBase implements IHierarchicalOptionListValue {
    readonly values: Array<IHierarchicalOptionListValue>;

    constructor(identifier: string, labels?: MapCultureTo<string>, values?: Array<IHierarchicalOptionListValue>) {
        super(identifier, labels);
        //TODO add 'not all null' guard for values

        this.values = values || [];
    }
}

export { HierarchicalOptionListValue };
